export const TRACKER_KEY = 'PROMOTIONS_PROVIDE_TRACKER';
export const BASE_PATH = '/move-in-promotions';
export const PENSKE_ID = 'penske:promotion';
export const SML_ID = 'sml:promotion';

export const HARD_CODED_DATA = {
  [PENSKE_ID]: {
    coverImage: '/c_scale,w_335/penske_promotion_logo.jpg',
    value: 25,
    redemptionDescription: {
      html:
        'Visit <a href="//pensketruckrental.com" rel="noopener" target="_blank">pensketruckrental.com</a> to get a quote.',
    },
    rank: 5,
  },
  [SML_ID]: {
    coverImage: '/c_scale,w_335/sml_promotion_logo.jpg',
    value: 25,
    codeOverride: '<span>UPDATER</span>',
    redemptionDescription: {
      html:
        'Visit <a href="//simplemovinglabor.com" rel="noopener" target="_blank">simplemovinglabor.com</a> or call (866) 767-5348 to redeem. Must select “UPDATER” as your referral source.',
    },
    rank: 6,
  },
};
